/**
 * 请求 baseURL 推导 — standalone 模块。
 *
 * 本文件被标记为 standalone，表示它**不依赖** request 层的重模块（拦截器、store 等），
 * 仅依赖 runtime context 的叶子解析模块，因此可被任意目录安全引用，不会引发循环依赖。
 *
 * 跨目录引用方：
 *   - `@/request/index` — 全局 axios 实例设置 baseURL
 *   - `@/service/project-timezone` — 时区初始化独立 axios 实例设置 baseURL
 *   - `@/views/.../all-biz-micro-app-container` — 微前端子应用透传 baseURL（经由 re-export）
 */
import { getRuntimeContext } from '@/runtime/context';

/** 根据当前环境推导 API 请求的 baseURL */
export const getRequestBaseURL = (runtime = getRuntimeContext()): string => {
  const host = runtime.transport.proxyBaseUrl || runtime.backend.apiHost;
  return `${location.protocol}//${host}/`;
};
